module.exports = __webpack_public_path__ + "img/corporate-man.94589f01.png";